export default {
    title: 'Neue Token vergeben',
    description: 'Für die ausgewählten Bezirke werden neue zufällige Token erstellt. Die alten Token werden dabei überschrieben.',
    createTokens: 'Token erstellen',
    generatedTokens: 'Token wurden erstellt.'
}